// src/context/FabricContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { BASE_URL, UPLOAD_URL } from "../config/config";
const FabricContext = createContext();

export const FabricProvider = ({ children }) => {
  const [fabrics, setFabrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFabrics = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/fabric`);
      const data = await response.json();

      if (data.status === 200) {
        setFabrics(data.data);
      } else {
        throw new Error("Failed to load fabrics");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFabrics();
  }, []);

  return (
    <FabricContext.Provider value={{ fabrics, loading, error, fetchFabrics }}>
      {children}
    </FabricContext.Provider>
  );
};

export const useFabrics = () => useContext(FabricContext);
